<app-title-bar rootBreadCrumbs="['i18n.core.navigation.parking']" titleText="i18n.domain.parker-registration.title"></app-title-bar>
<div class="d-lg-flex align-items-center mb-2" [formGroup]="filterForm">
  <app-client-autocomplete [(selectedClient)]="selectedClient"
    class="client-autocomplete me-2"></app-client-autocomplete>
  @if (isAdmin) {
    <app-parker-name-autocomplete
      [clientId]="selectedClient?.id"
      [value]="filterForm.controls.parkerName.value"
      (valueChange)="onParkerNameChange($event)"
      [placeholder]="'i18n.domain.parker-registration.filter.parker-name' | translate"
      class="filter-element me-2">
    </app-parker-name-autocomplete>
    <app-license-plate-autocomplete
      [clientId]="selectedClient?.id"
      [value]="filterForm.controls.licensePlate.value"
      [initialText]="filterForm.controls.licensePlate.value"
      (valueChange)="onLicensePlateChange($event)"
      [placeholder]="'i18n.domain.parker-registration.filter.license-plate' | translate"
      class="filter-element me-2">
    </app-license-plate-autocomplete>
  }
  @if (selectedClient || isAdminCrossClientSearch) {
    <app-button-group class="me-2" formControlName="dataType" id="dataType" [fixedWidth]="false"
      [fieldsEnum]="ParkerRegistrationDataType"
      [translateKey]="'i18n.domain.parker-registration.data-type.'"></app-button-group>
  }
  @if (selectedClient && filterForm.controls.dataType.value === ParkerRegistrationDataType.Evaluated) {
    <div>
      <ejs-dropdownlist id="present-filter" [placeholder]="'i18n.domain.parker-registration.filter.present' | translate"
        [dataSource]="presentList$ | async" [fields]="dropdownSettings" [showClearButton]="true"
        class="filter-element me-2" formControlName="present"></ejs-dropdownlist>
    </div>
  }
  @if (selectedClient && filterForm.controls.dataType.value === ParkerRegistrationDataType.Evaluated) {
    <div>
      <ejs-dropdownlist id="zone-filter" [placeholder]="'i18n.domain.parker-registration.filter.zones' | translate"
        [dataSource]="zoneDropdownValues" [fields]="dropdownSettings" [showClearButton]="true" class="filter-element me-2"
        formControlName="zone"></ejs-dropdownlist>
    </div>
  }
  @if (selectedClient) {
    <div>
      <ejs-dropdownlist id="offense-type-filter" [placeholder]="'i18n.domain.parker-registration.filter.offense-type' | translate"
        [dataSource]="statusList$ | async" [fields]="dropdownSettings" [showClearButton]="true"
        class="filter-element me-2" formControlName="offenseType"></ejs-dropdownlist>
    </div>
  }
</div>

@if (selectedClient || isAdminCrossClientSearch) {
  @if (filterForm.controls.dataType.value === ParkerRegistrationDataType.Raw) {
    <app-parker-registration-raw-table #rawGrid [zones]="zones"></app-parker-registration-raw-table>
  }
  @if (filterForm.controls.dataType.value === ParkerRegistrationDataType.Evaluated) {
    <app-parker-registration-evaluated-table #evaluatedGrid [zones]="zones"></app-parker-registration-evaluated-table>
  }
}
